import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './plugins/element.js';
import htmlToPaper from './plugins/htmlToPaper.js';
import requester from './plugins/requester.js';

import Default from './layouts/default';
import Auth from './layouts/auth';
import MakMore from './components/MakMore';
import VueAnimateNumber from 'vue-animate-number';
import VueLocalStorage from 'vue-localstorage'
import moment from 'moment';

moment.locale('tr-tr');
Vue.config.productionTip = false;
Vue.use(VueLocalStorage);
Vue.use(requester);
Vue.use(htmlToPaper);

import 'vue-googlemaps/dist/vue-googlemaps.css';
import VueGoogleMaps from 'vue-googlemaps';
Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: 'AIzaSyCsOGB38ogd-U1bePAsfUmnZKVvMHpcqMs',
    // Enable more Google Maps libraries here
    libraries: ['places'],
    // Use new renderer
    useBetaRenderer: false,
  },
})

Vue.component('default-layout', Default);
Vue.component('auth-layout', Auth);
Vue.component('mak-more', MakMore);
Vue.use(VueAnimateNumber);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
